import * as Yup from "yup";

const FormControl = [
    {
        size: { xs: 12, sm: 6 },
        props: { id: "caption", label: "標題 *", type: "text" },
    },

    {
        size: { xs: 12, sm: 6 },
        variant: "selector",
        placeHolder: "請選擇",
        props: { id: "type", label: "類型" },
        options: [
            { value: "industry", label: "產業合作" },
            { value: "thei", label: "THEi" },
            { value: "school", label: "學校" },
            { value: "normal", label: "一般" },
        ],
    },
    {
        size: { xs: 12 },
        variant: "youtube_link",
        props: { id: "video_url", label: "影片 URL *", type: "text" },
    },
    {
        size: { xs: 12},
        props: { id: "thumbnail", label: "Cover縮圖 *", type: "text" },
    },
];

const Schema = Yup.object().shape({
    caption: Yup.string().required("請輸入標題"),
    video_url: Yup.string().url("請輸入有效的 URL").required("請輸入影片URL 或者 YouTube 連結"),
    type: Yup.string().required("請選擇類型"),    
});

const FormikInstance = {
    initialValues: {
        caption: "",
        thumbnail: "",
        video_url: "",
        type: "industry",
    },
    validateOnMount: true,
    validationSchema: Schema,
};

const FormContent = {
    Schema,
    FormControl,
    FormikInstance,
};

export default FormContent;
